var Handlebars = require('/Users/ben/Code/honeybadger/public-uptime/node_modules/handlebars/runtime.js');
module.exports = (Handlebars['default'] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class=\"loading-spinner\">\n    <i class=\"fa fa-cog fa-spin fa-2x fa-fw\"></i>\n    <span>Loading...</span>\n</div>";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./src/pending.hbs
// module id = 130
// module chunks = 0